<label
  class="wrapper"
  [class.invalid]="invalid"
  [class.disabled]="disabled"
  [class.regular]="size === 'regular'"
  [class.large]="size === 'large'"
>
  <ng-content></ng-content>
</label>
